/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Daily_Col_TypeInputs */

const vi_expense_daily_col_type = /** @type {(inputs: Expense_Daily_Col_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại`)
};

/**

* @param {Expense_Daily_Col_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_daily_col_type = /** @type {((inputs?: Expense_Daily_Col_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Daily_Col_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_daily_col_type(inputs)
});